import {
  createEconnectorClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  postRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { CreateUser, User } from './model';

const client = createEconnectorClient('/api/users');
const clientForUpdatePassword = createEconnectorClient('/api/users', { 'Content-Type': 'text/plain' });

export const userPermissions = {
  SEARCH: 'econnector.get-all-users',
  GET: 'econnector.get-user',
  CREATE: 'econnector.create-user',
  DELETE: 'econnector.delete-user',
  UPDATE_PASSWORD: 'econnector.change-password'
};

export const searchUsers: SearchOperation<User> = searchRequestFactory<User>(client, { permissionId: userPermissions.SEARCH });
export const getUser: FindOperation<User, string> = getRequestFactory<User, string>(client, { permissionId: userPermissions.GET });
export const createUser: SaveOperation<CreateUser, User> = postRequestFactory<CreateUser, User>(client, {
  pattern: '',
  permissionId: userPermissions.CREATE
});
export const updateUserPassword: SaveOperation<string, User> = putRequestFactory<string, User>(clientForUpdatePassword, {
  pattern: '/{id}/password',
  permissionId: userPermissions.UPDATE_PASSWORD
});
export const deleteUser: DeleteOperation<void, string> = deleteRequestFactory<void, string>(client, {
  permissionId: userPermissions.DELETE
});
